import { getAllowedOrigins } from './allowed_origins';

import InvalidOriginException from "./exceptions/invalid_origin_exception"
import InvalidPostMessageEventException from  "./exceptions/invalid_post_message_event_exception"

import EventHandler from '../events/event_handler';

export const PostMessageEventHandler = new EventHandler();

const handleAllowedOriginsResponse = (event, allowedOrigins) => {
	return new Promise((resolve, reject) => {
		const origin = event.origin || event.originalEvent.origin;
		const isAllowedOrigin = allowedOrigins.includes(origin) || allowedOrigins.includes("*");

		if (!isAllowedOrigin) reject(new InvalidOriginException(origin));
		else if(!event.data || !event.data.event) reject(new InvalidPostMessageEventException(event));
		else resolve(event, allowedOrigins);
	});
};

const logPostMessageExceptions = (error) => {
	// if (process.env.NODE_ENV === 'production') console.error(error);
};

const publishPostMessage = (event) => {
	PostMessageEventHandler.publish(event.data.event, event.data, event)
};

window.addEventListener("message", (event) => {
	getAllowedOrigins()
	.then(handleAllowedOriginsResponse.bind(null, event))
	.then(publishPostMessage)
	.catch(logPostMessageExceptions);
});

export default PostMessageEventHandler;
